module.exports = __webpack_public_path__ + "static/media/brand2-large.f96206f1.jpg";